import React from 'react'

import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import styled from 'styled-components'

import { lazyWithVersionCheck } from '@libs/typescript-utils'

import { hasActiveSubscription } from '@helpers'

import CompanyDialogsController from '@components/CompanyDialogsController'
import { PrivateNavbar } from '@components/navigations'
import { PageLoadingErrorView, PageLoadingView } from '@components/ui'
import { InitializeUser } from '@oldComponents/InitializeUser'

import { generateMaxHeightBreakPoint } from '@constants/index'

import { DashboardErrorBoundary } from '../DashboardRoutes/DashboardErrorBoundary'

// code splitting - async component import
const AsyncOauthAuthorizePage = lazyWithVersionCheck(
  () => import('@components/pages/OauthAuthorizePage'),
  PageLoadingErrorView
)
const AsyncNotFoundPrivatePage = lazyWithVersionCheck(
  () => import('@components/pages/NotFoundPage/NotFoundPrivatePage'),
  PageLoadingErrorView
)

const WrapperDiv = styled.div`
  min-height: 500px;
  color: ${({ theme }) => theme.colors.common.offBlack};
  padding-top: ${({ theme }) => theme.appBarHeight}px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  ${generateMaxHeightBreakPoint('medium')} {
    padding-top: ${({ theme }) => theme.appBarHeightMedium}px;
  }
`

interface OAuthRoutesProps {
  hasSubscription: boolean
  isUserDetailsFetched: boolean
}

export function PureOAuthRoutes({ hasSubscription, isUserDetailsFetched }: OAuthRoutesProps) {
  return isUserDetailsFetched ? (
    <WrapperDiv>
      <PrivateNavbar hasSubscription={hasSubscription} withoutLinks />
      <DashboardErrorBoundary>
        <React.Suspense fallback={<PageLoadingView />}>
          <Routes>
            <Route path="authorize" element={<AsyncOauthAuthorizePage />} />
            <Route path="*" element={<AsyncNotFoundPrivatePage />} />
          </Routes>
        </React.Suspense>
      </DashboardErrorBoundary>
      <CompanyDialogsController />
    </WrapperDiv>
  ) : (
    <InitializeUser />
  )
}

export const OAuthRoutes = connect((state: Store) => ({
  hasSubscription: hasActiveSubscription(state),
  isUserDetailsFetched: Boolean(state.auth.user),
}))(PureOAuthRoutes)

OAuthRoutes.displayName = 'OAuthRoutes'
